import { useNavigate } from "react-router-dom";

import { SiteHeader } from "../../components/header/header";
import "../../styles/terms.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard, faEnvelope, faIdBadge, faLegal, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";

export const ImprintPage = () => {
    const navigateTo = useNavigate();
    return (
        <div className="page-body flx-col">
            <SiteHeader
                title={"Kontakt"}
                navAction={() => {
                    navigateTo("/", { state: "service" })
                }}
            />
            <div className="app-body flx-col">
                <div className="upper-page">
                    <div className="service-call-container flx-rw c-al c-jt">
                        <span className="prim-dot" ></span>
                        <div className="service-text">
                            Rechtliches
                        </div>
                    </div>
                    <div className="page-title">
                        Impressum
                    </div>
                    <div className="title-context">
                        Angaben gemäß § 5 TMG
                    </div>
                </div>
                <div className="imprint-unit">
                    <div className="imprint-caption">_Adresse:</div>
                    <div className="imprint-point flx-rw">
                        <FontAwesomeIcon icon={faAddressCard} className="impr-icon" />
                        <span className="imprint-text">
                            ACT-Umzugs und Reinigungs UG
                        </span>
                    </div>
                    <div className="imprint-point flx-rw">
                        <FontAwesomeIcon icon={faAddressCard} className="impr-icon" />
                        <span className="imprint-text">
                            Brigittte-Reimann 27,12629 Berlin
                        </span>
                    </div>
                </div>
                <div className="imprint-unit">
                    <div className="imprint-caption">_Kontakt:</div>
                    <div className="imprint-point flx-rw">
                        <FontAwesomeIcon icon={faPhoneAlt} className="impr-icon" />
                        <span className="imprint-text">
                            +4917622006681
                        </span>
                    </div>
                    <div className="imprint-point flx-rw">
                        <FontAwesomeIcon icon={faEnvelope} className="impr-icon" />
                        <span className="imprint-text">
                            actreinigung@gmail.com
                        </span>
                    </div>
                </div>
                <div className="imprint-unit">
                    <div className="imprint-caption">_Registereintrag:</div>
                    <div className="imprint-point flx-rw">
                        <FontAwesomeIcon icon={faLegal} className="impr-icon" />
                        <span className="imprint-text">
                            Registereintrag: Eintragung im Handlesregister
                        </span>
                    </div>
                    <div className="imprint-point flx-rw">
                        <FontAwesomeIcon icon={faLegal} className="impr-icon" />
                        <span className="imprint-text">
                            Registergericht: Amtsgericht Berlin Charlottenburg
                        </span>
                    </div>
                    <div className="imprint-point flx-rw">
                        <FontAwesomeIcon icon={faLegal} className="impr-icon" />
                        <span className="imprint-text">
                            Registernummer: HRB 257062 B
                        </span>
                    </div>
                </div>
                <div className="imprint-unit">
                    <div className="imprint-caption">_Umsatzsteuer-ID:</div>
                    <div className="imprint-point flx-rw">
                        <FontAwesomeIcon icon={faIdBadge} className="impr-icon" />
                        <span className="imprint-text">
                            Umsatzsteuer-ID: Umsatzsteuer-Identifikationsnummer gemäß §27 a
                        </span>
                    </div>
                    <div className="imprint-point flx-rw">
                        <FontAwesomeIcon icon={faIdBadge} className="impr-icon" />
                        <span className="imprint-text">
                            Umsatzsteuergesetz: DE363532456
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}